import type { CommonJobData, SimilarJob } from "../types/job";

/**
 * Converts a JobData (or any CommonJobData-extending type) into a SimilarJob
 * for use with WatchJobButton and localStorage storage.
 */
export function toSimilarJob(data: CommonJobData): SimilarJob {
  return {
    idClient: data.idClient,
    title: data.title,
    city: data.locations?.[0]?.city ?? "",
    country: data.locations?.[0]?.country ?? "",
    company: data.company ?? "",
    entryLevel: data.entryLevel ?? "",
    postingDate: data.postingDate ?? "",
    jobField: Array.isArray(data.jobField)
      ? (data.jobField[0] ?? "")
      : (data.jobField ?? ""),
    applicationUrl: data.applicationUrl ?? "",
  };
}
